import { KeyValue } from '@/main/models/common';
import { Result } from '@/main/models/common/resultResponse';
import { AxiosResponse } from 'axios';
import { api, IProcurementReportScheduleStatusAPI } from '../base';

const baseRoute: string = 'ProcurementReportScheduleStatus';

export class ProcurementReportScheduleStatusAPI extends IProcurementReportScheduleStatusAPI {
  getProcurementReportScheduleStatus(): Promise<
    AxiosResponse<Result<KeyValue[]>>
  > {
    return api.get(`${baseRoute}/getprocurementreportschedulestatus`);
  }
}

